import { render, staticRenderFns } from "./home.vue?vue&type=template&id=58ba56b4&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./home.vue?vue&type=style&index=0&id=58ba56b4&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "58ba56b4",
  "7cafc4c0"
  
)

export default component.exports